export enum MarketingType {
  ADMIN = 'ADMIN', //belong to TL
  ORGANIZATION = 'ORGANIZATION', //belong to an organization
}

export enum MarketingSubjectType {
  USER = 'user',
  MANAGEMENT_USER = 'managementUser',
  CUSTOMER = 'customer',
  EXTERNAL = 'external',
}

export enum MarketingContactStatus {
  ACTIVE = 'active',
  UNSUBSCRIBED = 'unsubscribed',
  BOUNCED = 'bounced',
  COMPLAINED = 'complained',
}

export enum MarketingChannel {
  EMAIL = 'email',
  SMS = 'sms',
  WHATSAPP = 'whatsapp',
}

export enum MarketingListVisibility {
  INTERNAL = 'internal',
  CUSTOMER_VISIBLE = 'customer_visible',
}

export enum MarketingListMembershipStatus {
  ACTIVE = 'active',
  UNSUBSCRIBED = 'unsubscribed',
}

export enum MarketingEmailProvider {
  SES = 'ses',
}

export enum MarketingSmsProvider {
  TWILIO = 'twilio',
  TELNYX = 'telnyx',
}

export enum MarketingWhatsAppProvider {
  TWILIO = 'twilio',
}

/** Tablelist-owned corporate lists synced to Mautic (env maps slug → segment id). */
export enum MarketingCorporateListSlug {
  CONSUMER_MARKETING_UPDATES = 'consumer_marketing_updates',
  CONSUMER_PRODUCT_UPDATES = 'consumer_product_updates',
  B2B_PRODUCT_UPDATES = 'b2b_product_updates',
  B2B_VENUE_PARTNER_UPDATES = 'b2b_venue_partner_updates',
  B2B_PROMOTIONS = 'b2b_promotions',
}

export enum MarketingCampaignStatus {
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
  SENDING = 'sending',
  SENT = 'sent',
  CANCELLED = 'cancelled',
}

export enum MarketingTemplateStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export enum MarketingTemplateHistoryEventType {
  DRAFT_SAVE = 'draft_save',
  PUBLISH = 'publish',
  VERSION_RESTORE = 'version_restore',
}

export enum MarketingTemplateHistorySource {
  MANUAL = 'manual',
  AUTOSAVE = 'autosave',
  SYSTEM = 'system',
}

export enum MarketingUnsubscribeChannel {
  EMAIL = 'email',
  SMS = 'sms',
}

export enum MarketingSegmentDefinitionKind {
  ADMIN_CORPORATE_LIST = 'adminCorporateList',
  ADMIN_SUBJECT_TYPE = 'adminSubjectType',
  ADMIN_EMAIL_OPT_IN = 'adminEmailOptIn',
  ADMIN_PURCHASED_IN_LAST_DAYS = 'adminPurchasedInLastDays',
  ORGANIZATION_EVENT_ATTENDEES = 'organizationEventAttendees',
  ORGANIZATION_EVENT_WAITLIST = 'organizationEventWaitlist',
  ORGANIZATION_PAST_GUESTS = 'organizationPastGuests',
  ORGANIZATION_SIMILAR_CUSTOMERS = 'organizationSimilarCustomers',
  ORGANIZATION_PURCHASED_IN_LAST_DAYS = 'organizationPurchasedInLastDays',
  ORGANIZATION_EVENT_TICKET_BUYERS = 'organizationEventTicketBuyers',
}
